<template>
  <div>
    <!-- 제목 -->
    <v-sheet outlined class="d-flex align-center ma-2 px-4" height="60">
      <font class="font-weight-bold text-h6 grey--text text--darken-2">얼리버드 상품 관리</font>
    </v-sheet>

    <!-- 본문 -->
    <v-sheet class="pa-2 ma-2">
      <v-sheet outlined class="pa-2 mb-2 d-flex">
        <v-sheet class="d-flex" width="660">
          <!-- 키워드 -->
          <v-text-field placeholder="검색어를 입력해주세요" outlined dense hide-details v-model="keyword" @keyup.enter="search()"></v-text-field>

          <!-- 제출 버튼 -->
          <v-btn height="40" class="px-6 ml-3" color="primary" dark depressed @click="search()">
            <v-icon small left>mdi-magnify</v-icon>
            검색하기
          </v-btn>

          <!-- 활성화 여부 체크 박스-->
          <v-checkbox v-model="isEnabled" class="shrink mt-0 ml-4" label="유효한 상품만" color="primary" hide-details dense> 유효한 상품만</v-checkbox>
        </v-sheet>
      </v-sheet>

      <v-radio-group v-model="selected" hide-details>
        <v-data-table
          :headers="tableHeaders"
          item-key="id"
          :items="items"
          :loading="loading"
          loading-text="Loading... Please wait"
          :server-items-length="totalCount"
          :options.sync="options"
          :footer-props="{
            'items-per-page-options': [10, 20, 30, 40, 50],
            'show-current-page': true,
            'show-first-last-page': true,
          }"
          :page.sync="pageNum"
        >
          <template v-slot:[`item.radio`]="{ item }">
            <v-radio class="ml-1" hide-details dense :value="item" @change="selectedItem = item"></v-radio>
          </template>
          <template v-slot:[`item.promotionCodes`]="{ item }">
            <v-chip class="ma-1" v-for="(promotion, index) in item.promotionCodes.split(',')" :key="promotion + index" small>{{ promotion }}</v-chip>
          </template>
          <template v-slot:[`item.thumbnail`]="{ item }">
            <v-img height="80" :src="'/upload/concept/thumbnail_image/' + item.thumbnail_image"></v-img>
          </template>
          <template v-slot:[`item.baseAmount`]="{ item }">
            <span>{{ $toComma(item.baseAmount) }}원</span>
          </template>
          <template v-slot:[`item.startAt`]="{ item }">
            <span>{{ dayjs(item.startAt).format("YYYY.MM.DD") }}</span>
          </template>
          <template v-slot:[`item.endAt`]="{ item }">
            <span>{{ dayjs(item.endAt).format("YYYY.MM.DD") }}</span>
          </template>
          <template v-slot:[`item.created`]="{ item }">
            <span>{{ dayjs(item.created).format("YYYY.MM.DD") }}</span>
          </template>
        </v-data-table>
      </v-radio-group>

      <!-- 버튼 -->
      <v-card class="mt-2 pa-2 d-flex justify-end" outlined>
        <v-btn class="px-6 ml-3" color="primary" large dark depressed @click="openUrl()" outlined>
          <v-icon small left>mdi-open-in-new</v-icon>
          OPEN LINK
        </v-btn>

        <v-btn class="px-6 ml-3" color="green" large dark depressed @click="updateOpen()">
          <v-icon small left>mdi-database-edit-outline</v-icon>
          수정하기
        </v-btn>

        <v-btn class="px-6 ml-3" color="blue" large dark depressed @click="createProduct()">
          <v-icon small left>mdi-database-plus-outline</v-icon>
          추가하기
        </v-btn>
        <v-btn class="px-6 ml-3" color="red" large dark depressed @click="deleteItem()">
          <v-icon small left>mdi-database-remove-outline</v-icon>
          삭제하기
        </v-btn>
      </v-card>
    </v-sheet>
    <InsertEarlyProduct @input="(e) => (showInsertDialog = e)" :visible="showInsertDialog" :key="'insert' + insertComponentKey" @complete="insertComplete" />

    <UpdateEarlyProduct @input="(e) => (showUpdateDialog = e)" :visible="showUpdateDialog" :key="'update' + updateComponentKey" :item="selectedItem" @complete="updateComplete" />
  </div>
</template>
<script>
import { computed } from "vue"
import InsertEarlyProduct from "./InsertEarlyProduct"
import UpdateEarlyProduct from "./UpdateEarlyProduct"

export default {
  components: {
    InsertEarlyProduct,
    UpdateEarlyProduct,
  },
  data: () => ({
    tableHeaders: [
      { text: "", value: "radio", sortable: false, width: "52px" },
      { text: "상품명", value: "productName", sortable: false },
      { text: "썸네일", value: "thumbnail", sortable: false },
      { text: "컨셉명", value: "conceptName", sortable: false },
      { text: "프로모션 목록", value: "promotionCodes", sortable: false },
      { text: "한줄 설명", value: "subTitle", sortable: false },
      { text: "Base금액", value: "baseAmount", sortable: false },
      { text: "시작일", value: "startAt", sortable: false },
      { text: "종료일", value: "endAt", sortable: false },
      { text: "생성일", value: "created", sortable: false },
    ],

    keyword: "",
    isEnabled: true,

    loading: false,
    items: [],
    selected: false,
    selectedItem: null,
    promotions: [],
    pageNum: 1,
    options: {},
    totalCount: 0,

    showInsertDialog: false,
    insertComponentKey: 0,

    showUpdateDialog: false,
    updateComponentKey: 0,
  }),

  provide() {
    return {
      promotions: computed(() => this.promotions),
    }
  },

  watch: {
    isEnabled() {
      this.search()
    },
    options: {
      handler() {
        this.search(this.options.page, this.options.itemsPerPage)
      },
      deep: true,
    },
  },

  mounted() {
    this.$http
      .post("/api/promotion/select/admin/search", {
        params: {
          enabled: true,
          isNotTraveler: true,
        },
      })
      .then((res) => {
        this.promotions = res.data
      })

    this.search()
  },

  methods: {
    async search(page = 1, itemPerPage = 10) {
      this.loading = true
      try {
        const result = await this.$http.get("/api/early/admin/list", {
          params: {
            isEnabled: this.isEnabled,
            limit: itemPerPage,
            offset: (page - 1) * itemPerPage,
          },
        })
        this.items = result.data.data
        this.totalCount = result.data.totalCount
      } catch (e) {
        console.log(e)
        alert("정보를 가져오지 못했습니다.")
      } finally {
        this.loading = false
      }
    },

    createProduct() {
      this.showInsertDialog = true
      this.insertComponentKey++
    },
    updateOpen() {
      if (!this.selectedItem || !this.selectedItem.id) {
        this.$toast.error("선택한 아이템이 없습니다")
        return
      }
      this.showUpdateDialog = true
      this.updateComponentKey++
    },
    deleteItem() {
      if (!this.selectedItem) {
        alert("상품을 선택해 주세요.")
        return
      }
      this.$http
        .delete(`/api/early/admin/product/${this.selectedItem.id}`)
        .then((res) => {
          this.$toast.success("삭제하였습니다.")
          this.search()
        })
        .catch((e) => {
          this.$toast.error("삭제를 하지 못했습니다.")
        })
    },

    insertComplete() {
      this.showInsertDialog = false
      this.search()
      this.selectedItem = null
      this.selected = false
    },

    updateComplete() {
      this.showUpdateDialog = false
      this.search()
      this.selectedItem = null
      this.selected = false
    },

    openUrl() {
      if (!this.selectedItem || !this.selectedItem.id) {
        alert("선택한 아이템이 없습니다")
      } else {
        let url = window.location.origin + "/reservation/package/earlyDetail?id=" + this.selectedItem.id
        window.open(url, "_blank")
      }
    },
  },
}
</script>
<style></style>
